import axios from 'axios';

import URL from '../utils/urls';
import { registerUser, resetPassword, changeUserPassword } from '../utils/apiService';

import { createUser, createUserAdmin, updateUser as editUser, editUserProfile, getAdmins } from '../utils/apiService';
import { getFilteredUsers } from '../utils/apiService';

export const CREATE_USER = 'user/CREATE_USER';
export const CREATE_USER_PENDING = 'user/CREATE_USER_PENDING';
export const CREATE_USER_FULFILLED = 'user/CREATE_USER_FULFILLED';
export const CREATE_USER_REJECTED = 'user/CREATE_USER_REJECTED';

export const CREATE_USER_ADMIN = 'user/CREATE_USER_ADMIN';
export const CREATE_USER_ADMIN_PENDING = 'user/CREATE_USER_ADMIN_PENDING';
export const CREATE_USER_ADMIN_FULFILLED = 'user/CREATE_USER_ADMIN_FULFILLED';
export const CREATE_USER_ADMIN_REJECTED = 'user/CREATE_USER_ADMIN_REJECTED';

export const RESET_PASSWORD = 'user/RESET_PASSWORD';
export const RESET_PASSWORD_PENDING = 'user/RESET_PASSWORD_PENDING';
export const RESET_PASSWORD_REJECTED = 'user/RESET_PASSWORD_REJECTED';
export const RESET_PASSWORD_FULFILLED = 'user/RESET_PASSWORD_FULFILLED';

export const CHANGE_PASSWORD = 'user/CHANGE_PASSWORD';
export const CHANGE_PASSWORD_PENDING = 'user/CHANGE_PASSWORD_PENDING';
export const CHANGE_PASSWORD_REJECTED = 'user/CHANGE_PASSWORD_REJECTED';
export const CHANGE_PASSWORD_FULFILLED = 'user/CHANGE_PASSWORD_FULFILLED';

export const REGISTER = 'user/REGISTER';
export const REGISTER_PENDING = 'user/REGISTER_PENDING';
export const REGISTER_FULFILLED = 'user/REGISTER_FULFILLED';
export const REGISTER_REJECTED = 'user/REGISTER_REJECTED';

export const SIGN_IN = 'user/SIGN_IN';
export const SIGN_IN_PENDING = 'user/SIGN_IN_PENDING';
export const SIGN_IN_REJECTED = 'user/SIGN_IN_REJECTED';
export const SIGN_IN_FULFILLED = 'user/SIGN_IN_FULFILLED';
export const SIGN_OUT = 'user/SIGN_OUT';

export const QUOTE_SIGN_IN = 'user/QUOTE_SIGN_IN';
export const QUOTE_SIGN_IN_PENDING = 'user/QUOTE_SIGN_IN_PENDING';
export const QUOTE_SIGN_IN_REJECTED = 'user/QUOTE_SIGN_IN_REJECTED';
export const QUOTE_SIGN_IN_FULFILLED = 'user/QUOTE_SIGN_IN_FULFILLED';

export const UPDATE_USER = 'user/UPDATE_USER';
export const UPDATE_USER_PENDING = 'user/UPDATE_USER_PENDING';
export const UPDATE_USER_FULFILLED = 'user/UPDATE_USER_FULFILLED';
export const UPDATE_USER_REJECTED = 'user/UPDATE_USER_REJECTED';

export const UPDATE_USER_PROFILE = 'user/UPDATE_USER_PROFILE';
export const UPDATE_USER_PROFILE_PENDING = 'user/UPDATE_USER_PROFILE_PENDING';
export const UPDATE_USER_PROFILE_FULFILLED = 'user/UPDATE_USER_PROFILE_FULFILLED';
export const UPDATE_USER_PROFILE_REJECTED = 'user/UPDATE_USER_PROFILE_REJECTED';

export const LIST_ADMIN = 'user/LIST_ADMIN';
export const LIST_ADMIN_PENDING = 'user/LIST_ADMIN_PENDING';
export const LIST_ADMIN_REJECTED = 'user/LIST_ADMIN_REJECTED';
export const LIST_ADMIN_FULFILLED = 'user/LIST_ADMIN_FULFILLED';

export const FETCH_USER='user/FETCH_USER';
export const FETCH_USER_PENDING='user/FETCH_USER_PENDING';
export const FETCH_USER_REJECTED='user/FETCH_USER_REJECTED';
export const FETCH_USER_FULFILLED='user/FETCH_USER_FULFILLED';


export function signIn(user) {
    
    const request = axios.post(URL.login, user);

    return {
        type: SIGN_IN,
        payload: request
    }
}

export const fetchFilteredUsers=(filter)=>{
    const payload=getFilteredUsers(filter);
    return {
        type:FETCH_USER,
        payload
    }
}


export const quoteSignIn = (username, password) => {
    const payload = axios.post(URL.login, {
        username, password
    });

    return {
        type: QUOTE_SIGN_IN,
        payload
    }
}

export function logOut(){
    sessionStorage.removeItem('user');
    return {
        type: SIGN_OUT
    }
}

export const signUp = (user) => {
    const payload = registerUser(user);
    return {
        type: REGISTER,
        payload
    }
}

export const forgotPassword = (username) => {
    const payload = resetPassword(username);
    return {
        type: RESET_PASSWORD,
        payload
    }
}

export const changePassword = (user) => {
    const payload = changeUserPassword(user);
    return {
        type: CHANGE_PASSWORD,
        payload
    }
}

export const saveUser= (user) => {
    const payload = createUser(user);
    return {
        type: CREATE_USER,
        payload
    }
}

export const saveAdmin = (user) => {
    const payload = createUserAdmin(user);
    return {
        type: CREATE_USER_ADMIN,
        payload
    }
}

export const updateUser = (user) => {
    const payload = editUser(user);
    return {
        type: UPDATE_USER,
        payload
    }
}

export const updateUserProfile = (user) => {
    return {
        type: UPDATE_USER_PROFILE,
        payload: editUserProfile(user)
    }
}

export const listAdmins = (company) => {
    const payload = getAdmins(company);
    return {
        type: LIST_ADMIN,
        payload
    }
}



// WEBPACK FOOTER //
// ./src/actions/user.js